<template>
  <div class="layout--main">
    <DashboardNavbar />
    <DashboardControll />
    <vs-popup title="" button-close-hidden :active.sync="popupActivity">
      <div class="conditions__container">
        <img
          src="@/assets/images/logo/logo.png"
          alt="Recrutei logo"
          class="conditions__logo"
        />
        <p v-if="!disagree_of_terms" class="conditions__title">
          Atualizamos nossos Termos de uso e Política de privacidade
        </p>
        <p v-else class="conditions__title">
          Você tem certeza que não concorda com os termos?
        </p>
        <p v-if="!disagree_of_terms" class="conditions__description">
          Entendemos que você está de acordo com os novos termos de privacidade
          assim que clicar em concordo com os novos termos e continuar
          utilizando a Experiência de Talentos. Para consultar os termos, é só
          clicar nos links:
          <a
            href="https://recrutei.com.br/termos-de-uso"
            target="_blank"
            class="conditions__link"
            >Termos e condições de uso</a
          >
          e
          <a
            href="https://recrutei.com.br/privacidade-e-seguranca"
            target="_blank"
            class="conditions__link"
            >Política de privacidade</a
          >.
        </p>
        <p v-else class="conditions__description">
          Infelizmente para continuar utilizando a plataforma é necessário a
          concordância de ambas partes com os Termos de Uso e Política de
          Privacidade. Como você não concordou com as nossas Políticas, teremos
          que cessar a sua utilização na plataforma.
        </p>
        <vs-divider v-if="!disagree_of_terms" position="center" />
        <ul v-if="!disagree_of_terms">
          <li>
            <div class="conditions__checkbox-wrapper">
              <vs-checkbox v-model="conditions_terms">
                <span>Concordo com as </span>
                <a
                  href="https://recrutei.com.br/termos-de-uso"
                  target="blank"
                  >Termos e condições de uso</a
                >
              </vs-checkbox>
            </div>
          </li>
          <li>
            <div class="conditions__checkbox-wrapper">
              <vs-checkbox v-model="policy_and_privacy">
                <span>Concordo com as </span>
                <a
                  href="https://recrutei.com.br/privacidade-e-seguranca"
                  target="blank"
                  >Política de Privacidade</a
                >
              </vs-checkbox>
            </div>
          </li>
        </ul>
        <vs-divider position="center" />
        <vs-button
          v-if="!disagree_of_terms"
          class="mt-2"
          color="primary"
          type="filled"
          :disabled="!conditions_terms || !policy_and_privacy"
          @click="handleAgree"
          >Concordar com os novos termos</vs-button
        >
        <vs-button
          v-else
          class="mt-2"
          color="primary"
          type="border"
          @click="() => (disagree_of_terms = !disagree_of_terms)"
          >Revisar os novos termos</vs-button
        >
        <vs-button
          v-if="!disagree_of_terms"
          class="mt-5"
          color="danger"
          type="border"
          @click="() => (disagree_of_terms = !disagree_of_terms)"
          >Não concordo com os novos termos</vs-button
        >
        <vs-button
          v-else
          class="mt-5"
          color="danger"
          type="filled"
          @click="signOut"
          >Desejo encerrar a experiência</vs-button
        >
      </div>
    </vs-popup>
  </div>
</template>

<script>
import DashboardControll from "../components/dashboard/DashboardControll.vue";
import DashboardNavbar from "../components/dashboard/DashboardNavbar";

import { mapState } from "vuex";

export default {
  components: { DashboardNavbar, DashboardControll },
  computed: { ...mapState("company", ["company"]) },
  data: () => ({
    conditions_terms: false,
    policy_and_privacy: false,
    popupActivity: false,
    termsPopupActivity: false,
    policyPopupActivity: false,
    disagree_of_terms: false
  }),
  methods: {
    updatePrimaryColor() {
      if (
        this.company &&
        this.company.hasOwnProperty("base_hexcolor") &&
        this.company.base_hexcolor !== ""
      )
        this.$vs.theme({ primary: this.company.base_hexcolor });
    },
    handleAgree() {
      this.$http
        .put("api/v2/talents/condition-terms/update", {
          conditions_terms: this.conditions_terms,
          policy_and_privacy: this.policy_and_privacy
        })
        .then(() => {
          this.popupActivity = false;
        })
        .catch(() => {
          this.popupActivity = false;
        });
    },
    signOut() {
      this.popupActivity = false;

      this.$store.dispatch("basicInfo/clearBasicInfoState");
      this.$store.dispatch("address/clearAddressState");
      this.$store.dispatch("experience/clearExperienceState");
      this.$store.dispatch("language/clearLanguageState");
      this.$store.dispatch("formation/clearFormationState");
      this.$store.dispatch("skill/clearSkillState");
      this.$store.dispatch("step/clearStepsState");

      this.$store.dispatch("updateTab", 0);

      setTimeout(() => {
        this.$store.dispatch("auth/signOut", {
          router: this.$router
        });
      }, 100);
    },
    fetchConditionsTerms() {
      this.$http
        .get("/api/v2/talents/condition-terms/show")
        .then(response => {
          const { conditions_terms, policy_and_privacy } = response.data.data;

          this.conditions_terms = conditions_terms;
          this.policy_and_privacy = policy_and_privacy;

          this.popupActivity =
            !this.conditions_terms || !this.policy_and_privacy;
        })
        .catch(() => {});
    }
  },
  created() {
    window.scroll(0, 0);
    this.updatePrimaryColor();
    this.fetchConditionsTerms();
    this.$store.dispatch("steps/clearStepsState");
  }
};
</script>

<style lang="scss" scoped>
.conditions__container {
  display: flex;
  flex-direction: column;
  padding: 10px;

  hr {
    border-color: red;
  }
}

.conditions__logo {
  width: 80px;
  height: 80px;
  object-fit: contain;
  margin: 0 auto;
}

.conditions__title {
  text-align: center;
  margin-bottom: 20px;
}

.conditions__description {
  text-align: center;
  letter-spacing: 0.1px;
}

.conditions__checkbox-wrapper {
  display: flex;
  margin-bottom: 10px;

  span {
    font-size: 12px;
  }

  a {
    font-size: 12px;
  }
}
</style>
